/**
 * Miss row for Konjugation.
 *
 * The shared row prints `term → translation → what you typed`, which is wrong
 * here twice over: the translation was never the question, and "what you
 * typed" is eight things. What the user needs when scanning a finished session
 * is which forms of which verb did not come out first time, so the row names
 * the forms.
 */
import { MissRowFrame } from '@/components/practice/SharedMissRow';
import type { KonjugationPayload } from '@/core/types';

import type { MissRowProps } from '../types';

export function MissRow({ card, user_answer }: MissRowProps<KonjugationPayload>) {
  return (
    <MissRowFrame>
      <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-0.5">
        <span className="font-display text-base font-semibold">{card.de}</span>
        <span className="text-muted-foreground font-mono text-sm">{card.payload.praesens[2]}</span>
      </div>
      {user_answer ? (
        // "Not first try" rather than "needed a retry": since the reveal button
        // landed, a named form may have been shown rather than retyped, and
        // the row cannot tell which. Both mean the same thing to someone
        // scanning the session — that form did not come out.
        <div className="text-muted-foreground text-sm">
          Not first try: <span className="text-foreground font-medium">{user_answer}</span>
        </div>
      ) : (
        // A card where nothing was produced at all. Every other app renders
        // `null` as "skipped" via `UserAnswer`; this row used to render nothing,
        // which left the verb sitting in the missed list with no explanation
        // and read as a bug.
        <span className="text-muted-foreground text-sm italic">skipped</span>
      )}
    </MissRowFrame>
  );
}
